// ══════════════════════════════════════════════════════════════
// useRachaConexion (agregado 04/11/2026)
//
// Se llama desde DashboardLayout, que envuelve todas las páginas
// privadas. Escribe en Firestore como máximo una vez por día y por
// dispositivo (recuerda el último día registrado en localStorage).
//
// También vuelve a chequear al volver a la pestaña y cada 10 minutos,
// para el caso de quien deja la app abierta y pasa la medianoche.
// ══════════════════════════════════════════════════════════════

import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { RegistrarConexionDiaria } from "../firebase-racha";
import { getDiaClave } from "../utils/racha";

const INTERVALO_MS = 10 * 60 * 1000;

const useRachaConexion = () => {
  const { user } = useAuth();
  const uid = user?.uid;

  useEffect(() => {
    if (!uid) return;
    const key = `racha:${uid}`;
    let enCurso = false;

    const registrar = () => {
      const hoy = getDiaClave();
      try {
        if (localStorage.getItem(key) === hoy) return;
      } catch {
        // Sin localStorage seguimos: la transacción igual evita duplicados.
      }
      if (enCurso) return;
      enCurso = true;

      RegistrarConexionDiaria(uid)
        .then((estado) => {
          // Si el documento todavía no existe (usuario recién creado),
          // no marcamos el día: se reintenta en el próximo chequeo.
          if (!estado) return;
          try {
            localStorage.setItem(key, hoy);
          } catch {
            /* no crítico */
          }
        })
        .catch((error) => console.error("No se pudo registrar la racha:", error))
        .finally(() => {
          enCurso = false;
        });
    };

    registrar();

    const alVolver = () => {
      if (document.visibilityState === "visible") registrar();
    };
    document.addEventListener("visibilitychange", alVolver);
    const intervalo = window.setInterval(registrar, INTERVALO_MS);

    return () => {
      document.removeEventListener("visibilitychange", alVolver);
      window.clearInterval(intervalo);
    };
  }, [uid]);
};

export default useRachaConexion;
